export const DELETE = 'lottie/delete.json'
export const PROFILE = 'lottie/profile.json'